<template>
  <div
    v-if="(cookie_bar_show === '1') && (user_selected === false && CookieConsent === null)"
    :class="cookie_bar_enforce === '1' ? 'cookie-consent' : ''"
  >
    <section class="cookie-consent-bar">
      <div class="container" v-html="text_consent"></div>

      <div class="cookie-action-buttons">
        <div>
          <button
            @click="gotoPrivacyPolicy"
            class="btn btn-hover pull-left btn-primary"
          >{{ label_policy_link }}</button>
        </div>
        <div>
          <button
            @click="setCookieConsent(false)"
            class="btn btn-hover pull-left btn-primary"
          >{{ label_do_not_accept }}</button>
        </div>
        <div>
          <button
            @click="setCookieConsent(true)"
            class="btn btn-hover pull-left btn-primary"
          >{{ label_accept }}</button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    privacy_policy_link: {
      type: String,
      default: "/privacy-policy"
    },
    label_policy_link: {
      type: String,
      required: true,
      default: "Privacy Policy"
    },
    label_do_not_accept: {
      type: String,
      required: true,
      default: "Do Not Accept"
    },
    label_accept: {
      type: String,
      required: true,
      default: "Accept"
    },
    text_consent: {
      type: String,
      required: true,
      default: "text_consent"
    },
    cookie_bar_enforce: {
      type: String,
      default: "0"
    },
    cookie_bar_show: {
      type: String,
      default: "0"
    },
    analytics_tag: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      cookieConsentKey: "cookieConsent",
      user_selected: false
    };
  },
  mounted() {
    // console.log("this.hasCookieConsent", this.hasCookieConsent);
    this.addGoogleAnalytics();
  },
  methods: {
    gotoPrivacyPolicy() {
      window.location = this.privacy_policy_link;
    },
    setCookieConsent(val) {
      this.user_selected = true;
      return window.localStorage.setItem(this.cookieConsentKey, val);
    },
    addGoogleAnalytics() {
      if (
        (this.cookie_bar_show == "0" && this.analytics_tag != "") ||
        (this.hasCookieConsent === true && this.analytics_tag != "")
      ) {
        // alert(this.analytics_tag);

        $("head").append(this.analytics_tag);

        // $(this.analytics_tag).appendTo(document.head);
      }
    }
  },
  computed: {
    CookieConsent() {
      return window.localStorage.getItem(this.cookieConsentKey);
    },
    hasCookieConsent() {
      let cookieConsent = this.CookieConsent;

      if (cookieConsent === null) {
        if (this.cookie_bar_enforce === "1") {
          return false;
        }
        return true;
      }

      return cookieConsent === "true";
    }
  }
};
</script>
